import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FinancialSnapshotCardComponent } from '@brightnav/financial-snapshot';

/**
 * Finances tab host — vertical stack of collapsible Finances sections.
 * Add future `bn-collapsible-section` features here without touching FA layout.
 */
@Component({
  selector: 'bn-finances-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FinancialSnapshotCardComponent],
  template: `
    <div class="bn-finances-tab flex flex-col gap-4">
      <bn-financial-snapshot-card />
    </div>
  `,
})
export class FinancesTabComponent {}
